import { setInitialRecaptcha } from './services/captchaService.js';

const postHelpRequest = async ({ registerData, callback }) => {
    const response = await fetch('Statics/Help', {
        method: 'POST',
        body: registerData,
    });
    if (response.status !== 200 && callback !== undefined) {
        return callback();
    }
    if (response.status !== 200 && callback === undefined) {
        throw new Error(response.message);
    }
    return response.json();
};

const postWorkWithUsRequest = async ({ registerData, callback }) => {
    const response = await fetch('Statics/WorkWithUs', {
        method: 'POST',
        body: registerData,
    });
    if (response.status !== 200 && callback !== undefined) {
        return callback();
    }
    if (response.status !== 200 && callback === undefined) {
        throw new Error(response.message);
    }
    return response.json();
};

const submitHelp = document.getElementById('submitHelp');
if (submitHelp !== null) {
    submitHelp.addEventListener('click', function (event) {
        event.preventDefault();
        setInitialRecaptcha(window.recaptchaSiteKey).then(async (token) => {
            var placeholderForRecaptcha =
                document.getElementById('recaptchaRegister');

            placeholderForRecaptcha.value = token;
            try {
                const formId = document.getElementById('helpForm');
                if (formId !== null) {
                    const registerData = new FormData(formId);
                    const response = await postHelpRequest({
                        registerData,
                        callback: async () =>
                            await postHelpRequest({ registerData }),
                    });
                    if (response.isSuccess === true) {
                        window.location.href =
                            window.location.origin + response.url;
                    } else {
                        const validationSummary = document.querySelector(
                            '.validation-summary'
                        );
                        if (
                            validationSummary !== null &&
                            validationSummary !== undefined
                        ) {
                            let errors = '';
                            for (let i = 0; i < response.message.length; i++) {
                                errors += `<li>${response.message[i]}</li>`;
                            }

                            validationSummary.children[0].innerHTML = errors;
                        } else {
                            throw new Error('Validation errors');
                        }
                    }
                } else {
                    console.error('registerForm id not found');
                }
            } catch (error) {
                console.error(`Error in form `, error);
                alert(
                    'Oh no :( something went wrong. Please contact customer support.'
                );
            }
            const buttonsWait =
                document.getElementsByClassName('js-button-wait');
            for (let index = 0; index < buttonsWait.length; index++) {
                const buttonWait = buttonsWait[index];
                buttonWait.classList.remove('button--wait');
            }
        });
    });
}

const submitWorkWithUs = document.getElementById('submitWorkWithUs');
if (submitWorkWithUs !== null) {
    submitWorkWithUs.addEventListener('click', async function (event) {
        event.preventDefault();
        setInitialRecaptcha(window.recaptchaSiteKey).then(async (token) => {
            var placeholderForRecaptcha =
                document.getElementById('recaptchaRegister');

            placeholderForRecaptcha.value = token;
            try {
                const formId = document.getElementById('workWithUsForm');
                if (formId !== null) {
                    const registerData = new FormData(formId);
                    const response = await postWorkWithUsRequest({
                        registerData,
                        callback: async () =>
                            await postWorkWithUsRequest({ registerData }),
                    });
                    console.log(response);
                    if (response.isSuccess === true) {
                        window.location.href =
                            window.location.origin + response.url;
                    } else {
                        const validationSummary = document.querySelector(
                            '.validation-summary'
                        );
                        if (
                            validationSummary !== null &&
                            validationSummary !== undefined
                        ) {
                            let errors = '';
                            for (let i = 0; i < response.message.length; i++) {
                                errors += `<li>${response.message[i]}</li>`;
                            }

                            validationSummary.children[0].innerHTML = errors;
                        } else {
                            throw new Error('Validation errors');
                        }
                    }
                } else {
                    console.error('registerForm id not found');
                }
            } catch (error) {
                console.error(`Error in form `, error);
                alert(
                    'Oh no :( something went wrong. Please contact customer support.'
                );
            }
            const buttonsWait =
                document.getElementsByClassName('js-button-wait');
            for (let index = 0; index < buttonsWait.length; index++) {
                const buttonWait = buttonsWait[index];
                buttonWait.classList.remove('button--wait');
            }
        });
    });
}
